import { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { AddAlert, Button, Checkbox, Modal } from '../../../../component';
import { loaded, loading } from '../../../../layout/redux/layoutActions';
import { buildCoordinates } from '../../../../shared/utils/map';
import { refetchData } from '../../polygons/redux/polygonsActions';
import { editPolygons, savePolygons } from '../../polygons/redux/polygonsInfra';
import { modalOpen } from '../../redux/dashboardActions';
import { PayloadCreatePolygon, PayloadEditPolygon } from './types';
import Map from 'eemovel-map-library/src/data/google-maps/map';

export const SavePolygonsModal = (): JSX.Element => {
  const dispatch = useDispatch();
  const [polygonName, setPolygonName] = useState<string>('');
  const [isSelected, setIsSelected] = useState<string>('Privado');
  const { statusModal } = useSelector((state: any) => state.layoutState);
  const { preference } = useSelector((state: any) => state.layoutState);
  const { name, id } = useSelector(
    (state: any) => state.polygonsState.switches.toEdit
  );
  const isEditing = statusModal === 'edit polygons';
  const isCreating = statusModal === 'save polygons';
  const nls = require(`../nls/${preference.language.id}.json`);
  const access = [
    nls.actionsMap.savePolygons.modal.shared,
    nls.actionsMap.savePolygons.modal.private,
  ];

  const createPayloadSavePolygons = (
    action: 'create' | 'edit'
  ): PayloadCreatePolygon | PayloadEditPolygon => {
    const polygon = {
      title: polygonName,
      isFavorite: false,
      isPrivate: isSelected === nls.actionsMap.savePolygons.modal.private,
      ...(action === 'create' && {
        filterOptions: {
          coordinates: buildCoordinates()?.coordinates,
        },
      }),
      radius: buildCoordinates()?.radius,
    };
    return {
      polygon,
    };
  };

  const handleSavePolygons = async (text: 'create' | 'edit'): Promise<void> => {
    dispatch([loading(), modalOpen('')]);
    if (text === 'create') {
      try {
        const response = await savePolygons(createPayloadSavePolygons(text));
        if (response.status >= 400 && response.status < 600) {
          throw new Error('Bad response from server');
        }
        dispatch(
          AddAlert('success', nls.actionsMap.savePolygons.modal.successSaved)
        );
      } catch {
        dispatch(
          AddAlert('error', nls.actionsMap.savePolygons.modal.failSaved)
        );
      }
    } else {
      try {
        await editPolygons(id, createPayloadSavePolygons(text));
        dispatch(
          AddAlert(
            'success',
            `${name}${nls.actionsMap.savePolygons.modal.successEdited}`
          )
        );
      } catch {
        dispatch(
          AddAlert(
            'error',
            `${nls.actionsMap.savePolygons.modal.failEdited}${name}.`
          )
        );
      }
    }
    setPolygonName('');
    setIsSelected(nls.actionsMap.savePolygons.modal.private);
    dispatch([refetchData(), loaded()]);
  };

  return (
    <Modal
      title={
        <span data-cy="SavePolygonsTitle" className="text-primary">
          {isEditing
            ? nls.actionsMap.savePolygons.modal.editTitle
            : nls.actionsMap.savePolygons.modal.title}
        </span>
      }
      open={isCreating || isEditing}
      close={() => {
        setPolygonName('');
        setIsSelected(nls.actionsMap.savePolygons.modal.private);
        dispatch(modalOpen(''));
      }}
      closeText={nls.actionsMap.savePolygons.modal.closeText}
      cy="SavePolygons"
      closeBtnClasses="save-polygon-button-close"
      actions={
        <Button
          cy="SavePolygons"
          color="primary"
          onClick={() => {
            isEditing
              ? handleSavePolygons('edit')
              : handleSavePolygons('create');
          }}
          className="btn save-polygons-button-action"
          disabled={!polygonName}
        >
          {nls.actionsMap.savePolygons.modal.save}
        </Button>
      }
    >
      <div className="save-polygons-modal-actions-container">
        <div className="save-polygons-modal-checkbox">
          <label>{nls.actionsMap.savePolygons.modal.typeLabel}</label>
          <div className="save-polygons-modal-checkbox-container">
            {access.map((elem, index) => (
              <Checkbox
                key={index}
                cy={`SavePolygonsCheckbox${index}`}
                action={() => {
                  setIsSelected(elem);
                }}
                checked={elem === isSelected}
                name={elem}
                label={elem}
                type="checkbox"
              />
            ))}
          </div>
        </div>
        <div className="save-polygons-modal-input">
          <label htmlFor="savePolygonsInput">
            {nls.actionsMap.savePolygons.modal.nameLabel}
          </label>
          <input
            placeholder={
              isEditing
                ? name
                : nls.actionsMap.savePolygons.modal.inputPlaceholder
            }
            type="text"
            id="savePolygonsInput"
            maxLength={30}
            value={polygonName}
            onChange={(e) => {
              setPolygonName(e.target.value);
            }}
          />
          <p>{`${polygonName.length}/30`}</p>
        </div>
      </div>
    </Modal>
  );
};
